import { _decorator, UIRenderer, Color, CCInteger, tween, Tween } from 'cc';
import { DEV, EDITOR } from 'cc/env';
import MultiThemeComponent from './MultiThemeComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('MultiThemeColor')
@menu('MultiTheme/MultiThemeColor')
@requireComponent(UIRenderer)
export default class MultiThemeColor extends MultiThemeComponent<UIRenderer> {
    @property([Color])
    public readonly colors: Color[] = [];

    @property({ tooltip: DEV && '切換 Theme 時是否使用 Tween' })
    private readonly useTween: boolean = false;

    @property({
        type: [CCInteger],
        tooltip: DEV && '從當前 Theme 切換的 Tween 時長(ms)',
        visible() {
            return this.useTween;
        },
    })
    private readonly tweenDuration: number[] = [];

    private _tempColorA = new Color();
    private _tempColorB = new Color();

    public getMaxTheme(): number {
        return this.colors.length;
    }

    public updateColors(colors: Color[]) {
        this.colors.length = 0;
        this.colors.push(...colors);
        this.onThemeChanged();
    }

    protected getTarget() {
        return this.getComponent(UIRenderer);
    }

    protected onThemeChanged(setImmediately: boolean = false) {
        const color = this.colors[this._theme];
        if (!color) {
            return;
        }
        const isUsingTween = !EDITOR && !setImmediately && this.useTween;
        const tweenDuration = isUsingTween ? this.tweenDuration[this.lastTheme] / 1000 : 0;
        if (this.useTween) {
            Tween.stopAllByTarget(this.target);
        }

        if (tweenDuration) {
            this._tempColorA.set(this.target.color);
            tween(this.target)
                .update(tweenDuration, (target, ratio) => {
                    Color.lerp(this._tempColorB, this._tempColorA, color, ratio);
                    target.color = this._tempColorB;
                })
                .start();
        } else {
            this.target.color = color;
        }
    }
}
